// assets/malta-booking-fee.js
// Pré-requis : variante "Frais de réservation" (ID 53752592630098) au prix de 0,01 €.
(function(){
  'use strict';

  // ── CONFIG ──
  var FEE_VARIANT_ID = 53752592630098;
  var FEE_PRODUCT_ID = 10869332050258;
  var FEE_RATE       = 0.15;
  var EVENT_TEMPLATE = 'all-event-2026';
  var FEE_LABEL      = 'Frais de réservation';
  // ────────────

  var FEE_VID = String(FEE_VARIANT_ID);
  var SECTIONS = ['cart-drawer','cart-icon-bubble','main-cart-items','main-cart-footer','cart-live-region-text'];
  var syncing = false, queued = false, realCount = null, lastFeeCents = 0;
  var typeCache = {};

  function money(cents){ return '€' + (cents/100).toFixed(2).replace('.', ','); }

  function resolveEvents(cart){
    var need = [];
    cart.items.forEach(function(it){
      if (it.product_id === FEE_PRODUCT_ID) return;
      if (!(it.handle in typeCache) && need.indexOf(it.handle) === -1) need.push(it.handle);
    });
    return Promise.all(need.map(function(h){
      return fetch('/products/' + h + '.json').then(function(r){ return r.json(); })
        .then(function(d){ typeCache[h] = !!(d.product && d.product.template_suffix === EVENT_TEMPLATE); })
        .catch(function(){ typeCache[h] = false; });
    }));
  }
  function isEvent(item){ return typeCache[item.handle] === true; }

  function eventCents(cart){
    return cart.items.reduce(function(s,it){
      if (it.product_id === FEE_PRODUCT_ID) return s;
      return isEvent(it) ? s + it.final_line_price : s;
    }, 0);
  }
  function feeLine(cart){ return cart.items.find(function(it){ return it.variant_id === FEE_VARIANT_ID; }); }
  function computeRealCount(cart){
    var n = 0, feePresent = false;
    cart.items.forEach(function(it){ if (it.product_id === FEE_PRODUCT_ID) feePresent = true; else n += it.quantity; });
    return n + (feePresent ? 1 : 0);
  }
  function write(path, body){
    return fetch(path, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(body)});
  }

  function sync(){
    if (syncing){ queued = true; return; }
    syncing = true;
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      return resolveEvents(cart).then(function(){ return cart; });
    }).then(function(cart){
      realCount = computeRealCount(cart);
      var target = Math.round(eventCents(cart) * FEE_RATE);
      lastFeeCents = target;
      var line = feeLine(cart), cur = line ? line.quantity : 0;
      if (target === cur) return null;
      if (target === 0){ realCount -= 1; return write('/cart/change.js', {id:FEE_VID, quantity:0}); }
      if (!line) realCount += 1;
      return line ? write('/cart/change.js', {id:FEE_VID, quantity:target})
                  : write('/cart/add.js',    {id:FEE_VARIANT_ID, quantity:target});
    }).then(function(changed){ if (changed) return refreshUI(); })
      .catch(function(){})
      .then(function(){ syncing = false; tagDom(); fixBubble(); injectFeeRow(); if (queued){ queued = false; sync(); } });
  }

  function refreshUI(){
    return fetch('/?sections=' + SECTIONS.join(',')).then(function(r){return r.json();}).then(function(d){
      SECTIONS.forEach(function(id){
        var host = document.getElementById('shopify-section-' + id);
        if (host && d[id] != null) host.innerHTML = d[id];
      });
    }).catch(function(){});
  }

  function fixBubble(){
    if (realCount == null) return;
    document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble > span:first-child')
      .forEach(function(el){ el.textContent = realCount; });
    document.querySelectorAll('.cart-count-bubble').forEach(function(b){ if (realCount <= 0) b.style.display = 'none'; });
  }

  function tagDom(){
    document.querySelectorAll('[href*="' + FEE_VID + '"],[data-variant-id="' + FEE_VID + '"]').forEach(function(el){
      var row = el.closest('.cart-item, tr, [id^="CartDrawer-Item"], [id^="CartItem"]');
      if (row) row.classList.add('ma-fee-line');
    });
  }

  // injecte "Frais de réservation — montant" juste avant le bloc sous-total
  function injectFeeRow(){
    document.querySelectorAll('.ma-fee-row').forEach(function(n){ n.remove(); });
    if (!lastFeeCents) return;
    var anchors = document.querySelectorAll('.totals');
    if (!anchors.length){
      // fallback : repère le label "Sous-total"
      var found = [];
      document.querySelectorAll('.cart__footer, .cart-drawer__footer, [class*="footer"]').forEach(function(f){
        f.querySelectorAll('*').forEach(function(el){
          if (el.children.length === 0 && /sous-total|subtotal/i.test(el.textContent) && found.indexOf(el.parentElement) === -1)
            found.push(el.parentElement);
        });
      });
      anchors = found;
    }
    anchors.forEach(function(anchor){
      var row = document.createElement('div');
      row.className = 'ma-fee-row';
      row.innerHTML = '<span class="ma-fee-row__label">' + FEE_LABEL + '</span><span class="ma-fee-row__amount">' + money(lastFeeCents) + '</span>';
      anchor.parentNode.insertBefore(row, anchor);
    });
  }

  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?($|\?)/;
  var _fetch = window.fetch;
  window.fetch = function(input, init){
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var isWrite = CART_WRITE.test(url);
    var isOurs  = url.indexOf('/cart/change') > -1 && init && init.body && String(init.body).indexOf(FEE_VID) > -1;
    return _fetch.apply(this, arguments).then(function(res){
      if (isWrite && !isOurs && !syncing) setTimeout(sync, 90);
      return res;
    });
  };
  var _send = XMLHttpRequest.prototype.send, _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(m,u){ this.__u = u; return _open.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function(){
    var u = this.__u || '';
    if (CART_WRITE.test(u) && u.indexOf('/cart/change') === -1)
      this.addEventListener('load', function(){ setTimeout(sync, 90); });
    return _send.apply(this, arguments);
  };

  document.addEventListener('DOMContentLoaded', function(){ sync(); });
  document.addEventListener('shopify:section:load', function(){ tagDom(); fixBubble(); injectFeeRow(); });
})();